module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/feature2@1x.5e7506a.jpg";